import { ComponentChildren } from "preact";
import { Section } from "./Section.tsx";

interface ExperienceCardProps {
  iconSrc: string;
  iconAlt: string;
  title: string;
  description: string;
  cta?: ComponentChildren;
  children?: ComponentChildren
}

export function ExperienceCard(props: ExperienceCardProps) {
  return (
    <div style="background: rgba(255,255,255,0.1); padding: 2rem; border-radius: 15px; backdrop-filter: blur(10px);">
      <div style="text-align: center; margin-bottom: 1.5rem;">
        <img
          src={props.iconSrc}
          alt={props.iconAlt}
          style="width: 60px; height: 60px; filter: brightness(0) invert(1);"
        />
      </div>
      <h3 style="color: white; text-align: center; margin-bottom: 1rem;">{props.title}</h3>
      <p style="color: rgba(255,255,255,0.9); line-height: 1.6;">{props.description}</p>
      {props.children}
      {props.cta && (
        <div style="text-align: center; margin-top: 1.5rem;">
          {props.cta}
        </div>
      )}
    </div>
  );
}

export function ExperienceCards(props: { children: ComponentChildren }) {
  return (
    <Section data-accent>
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)); gap: 2rem; margin-top: 2rem;">
        {props.children}
      </div>
    </Section>
  );
}